import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkModalWindowRef, TLK_MODAL_WINDOW_DATA, TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { PopUpActions } from '@shared/models/enums/popup-modal-actions.enum';
import { StaticFilesEndpointPipe } from '@shared/pipes/static-files-endpoint.pipe';

export interface ConfimationDialogData {
	titleTranslationKey: string;
	contentTranslationKey: string;
	confirmTranslationKey?: string;
	cancelTranslationKey?: string;
}

@Component({
	selector: 'rx-change-confimation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [TranslateModule, StaticFilesEndpointPipe, TlkModalWindowModule, TlkButtonComponent, CloseEmptyIconComponent]
})
export class ConfirmationDialogComponent extends BaseDestroyableComponent {
	readonly popUpActions = PopUpActions;

	constructor(
		public dialogRef: TlkModalWindowRef<PopUpActions, ConfirmationDialogComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public data: ConfimationDialogData
	) {
		super();
	}

	closeWithAction(action: PopUpActions): void {
		this.dialogRef.close(action);
	}
}
